import { render } from "./EditWarehouse.vue?vue&type=template&id=0f6d6685"
import script from "./EditWarehouse.vue?vue&type=script&lang=js"
export * from "./EditWarehouse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__